// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RanaFile } from "./RanaFile";
import {
  RanaFileFromJSON,
  RanaFileFromJSONTyped,
  RanaFileToJSON,
  RanaFileToJSONTyped,
} from "./RanaFile";
import type { Dataset } from "./Dataset";
import {
  DatasetFromJSON,
  DatasetFromJSONTyped,
  DatasetToJSON,
  DatasetToJSONTyped,
} from "./Dataset";

/**
 *
 * @export
 * @interface CreateBasicHydroDataInput
 */
export interface CreateBasicHydroDataInput {
  /**
   *
   */
  pixelSize?: number;
  /**
   *
   */
  studyArea: RanaFile;
  /**
   *
   */
  soilDataset?: Dataset | null;
  /**
   *
   */
  landUseDataset?: Dataset | null;
  /**
   *
   */
  elevationDataset?: Dataset | null;
  /**
   *
   */
  landCoverDataset?: Dataset | null;
}

/**
 * Check if a given object implements the CreateBasicHydroDataInput interface.
 */
export function instanceOfCreateBasicHydroDataInput(
  value: object
): value is CreateBasicHydroDataInput {
  if (
    (!("studyArea" in (value as Record<string, any>)) &&
      !("study_area" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["studyArea"] === undefined &&
      (value as Record<string, any>)["study_area"] === undefined)
  )
    return false;
  return true;
}

export function CreateBasicHydroDataInputFromJSON(json: any): CreateBasicHydroDataInput {
  return CreateBasicHydroDataInputFromJSONTyped(json, false);
}

export function CreateBasicHydroDataInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateBasicHydroDataInput {
  if (json == null) {
    return json;
  }
  return {
    pixelSize: json["pixel_size"] == null ? undefined : json["pixel_size"],
    studyArea: RanaFileFromJSON(json["study_area"]),
    soilDataset:
      json["soil_dataset"] === undefined
        ? undefined
        : json["soil_dataset"] === null
        ? null
        : DatasetFromJSON(json["soil_dataset"]),
    landUseDataset:
      json["land_use_dataset"] === undefined
        ? undefined
        : json["land_use_dataset"] === null
        ? null
        : DatasetFromJSON(json["land_use_dataset"]),
    elevationDataset:
      json["elevation_dataset"] === undefined
        ? undefined
        : json["elevation_dataset"] === null
        ? null
        : DatasetFromJSON(json["elevation_dataset"]),
    landCoverDataset:
      json["land_cover_dataset"] === undefined
        ? undefined
        : json["land_cover_dataset"] === null
        ? null
        : DatasetFromJSON(json["land_cover_dataset"]),
  };
}

export function CreateBasicHydroDataInputToJSON(json: any): CreateBasicHydroDataInput {
  return CreateBasicHydroDataInputToJSONTyped(json, false);
}

export function CreateBasicHydroDataInputToJSONTyped(
  value?: CreateBasicHydroDataInput | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    pixel_size: value["pixelSize"],
    study_area: RanaFileToJSON(value["studyArea"]),
    soil_dataset: DatasetToJSON(value["soilDataset"]),
    land_use_dataset: DatasetToJSON(value["landUseDataset"]),
    elevation_dataset: DatasetToJSON(value["elevationDataset"]),
    land_cover_dataset: DatasetToJSON(value["landCoverDataset"]),
  };
}
